/**
 * Multi-PO TSH saves the whole allocation on field blur. Remove clicks blur the
 * amount field first, so that save is already in flight with the pre-delete rows.
 * A second save must wait, then send the list after the delete. The in-flight
 * result must not be written back onto the screen.
 */
export type ApInvoiceUpsSaveQueue = {
  inFlight: boolean;
  followUp: boolean;
};

export function createApInvoiceUpsSaveQueue(): ApInvoiceUpsSaveQueue {
  return { inFlight: false, followUp: false };
}

/** Start a save, or remember that a newer save is required when one is running. */
export function requestApInvoiceUpsSave(queue: ApInvoiceUpsSaveQueue): "start" | "defer" {
  if (queue.inFlight) {
    queue.followUp = true;
    return "defer";
  }
  queue.inFlight = true;
  queue.followUp = false;
  return "start";
}

/**
 * Call once when the in-flight save settles.
 * "again" means start another save immediately and ignore this result.
 */
export function settleApInvoiceUpsSave(queue: ApInvoiceUpsSaveQueue): "apply" | "again" {
  queue.inFlight = false;
  if (queue.followUp) {
    queue.followUp = false;
    queue.inFlight = true;
    return "again";
  }
  return "apply";
}
